import axios from 'axios'

// 创建axios实例
const QUEST_OVER_TIME = 1200 * 1000
const service = axios.create({
    baseURL: process.env.BASE_API, // api的base_url
    timeout: QUEST_OVER_TIME, // 请求超时时间
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js